<template>
<div>
    <AutoComplete id="Address"
        :items="addressList"
        v-on:input="search_addresses"
        v-on:set-result="set_result"
        v-on:no-results="noResults=true"
        v-on:cleared="cleared"
        aria-labelled-by="addresslabel"

        :isAsync="true" />
        <p class="error" v-if="noResults" v-html="$t('auto_complete.no_address')"></p>
</div>
</template>

<script>
import AutoComplete from './AutoComplete'
import _ from 'lodash'
import axios from 'axios'

export default {
    components: {
        AutoComplete,
    },

    data() {
        return {
            fetching: false,
            addresses: [],
            noResults: false,
        }
    },

    computed: {
        addressList() {
            var items = [];
            for (var i=0; i< this.addresses.length; i++) {
                items.push(this.addresses[i]);
            }
            return items;
        }
    },

    methods: {
        cleared() {
            this.noResults = false;
            this.addresses = [];
            this.$emit('typed-address','');
        },

        search_addresses: _.debounce(function(term) {
            this.$emit('typed-address',term)
            this.noResults = false;
            this.term = term;
            var parts = this.address_parts(term);
            if (parts.number) {

                if (!this.fetching) {
                    this.fetching = true;
                    var url = this.$ASSESSMENT_API + '&$where=street_number=' + parts.number + '%20AND%20street_name%20LIKE%20"' + parts.name.toUpperCase() + '%25"';
                    /*
                    if (parts.unit.length) {
                        url += ' AND unit_number="' + parts.unit + '"';
                    }
                    */
                    axios
                        .get(url)
                        .then(data => {
                            this.fetching = false;
                            if (data && data.data) {
                                this.addresses = data.data;
                            }
                        })
                        .catch(() => {
                            this.addresses = [];
                        });
                }
            }
        },250),

        address_parts(term) {
            var parts = {name: '', number: '', unit: ''};
            //var pattern = /(\d+)\s+(.+)/;
            var pattern = /(?=(\d+)\s*-\s*(\d+)\s(.*)|(\d+)\s(.*))/;
            var address_matches = term.match(pattern);
            if (address_matches == null) {
                return parts;
            }
            if (address_matches.length > 5) {
                if (address_matches[1] && address_matches[2] && address_matches[3]) {
                    //unit match
                    parts.unit = address_matches[1];
                    parts.number = address_matches[2];
                    parts.name = address_matches[3].trim();
                } else {
                    parts.number = address_matches[4];
                    parts.name = address_matches[5].trim();
                }
            }
            return parts;
        },

        set_result(result,idx) {
            this.addresses[idx].full_address = this.addresses[idx].street_number + ' ' + this.addresses[idx].street_name + ' ' + this.addresses[idx].street_type;
            this.$emit('address-found',this.addresses[idx]);
            this.addresses = [];
        },

    },

}
</script>

<style>

.error {
	color: red;
}

</style>
